import classnames from 'classnames';
import React from 'react';
import Icon from 'shared/components/icon';
import TextButton from 'src/components/TextButton';
import styles from './styles.module.scss';

interface Props {
  htmlContent: string;
  onDismiss: () => void;
}

export default function ToolbarNotificationDisplay({
  htmlContent,
  onDismiss,
}: Props): React.ReactElement {
  return (
    <div className={classnames(styles.root, 'toolbar-notification')}>
      <div className="toolbar-notification-content">
        <p dangerouslySetInnerHTML={{__html: htmlContent}}></p>
      </div>
      <TextButton
        aria-label="Dismiss notification"
        color="dark-gray"
        onClick={onDismiss}
        margin={false}
        className={classnames('toolbar-notification-dismiss', styles.dismissButton)}
        testid="dismiss-toolbar-notification"
      >
        <Icon iconType="times-r" />
      </TextButton>
    </div>
  );
}
